import React, {  PureComponent } from "react";
import { PointsHistoryStatus } from "./PointsHistoryConstants";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import {Api_Pagination} from 'RefRecordsConstants'
import Loading from "../../Utils/Loading";
import PointsHistory from "../PointsHistory"
export class PointsHistoryView extends PureComponent {
  constructor(props) {
    // alert("points")
    super(props);
    this.state = {
      open: true,
      activePage:props.activePage
    };
    // if(props.user_id !=="" && props.PointsHistory_GET_status !==PointsHistoryStatus.PointsHistory_GET.LOADING){
    //   // alert(nextProps.user_id)
    //   let data={
    //     user_id:props.user_id,
    //     offset:0
    //   }
    //   props.getPointsHistoryByUserId(data)
    //   props.clear_user_id()
    // }
    // this.getRiderUnAnsweredQuestions()
  }
componentWillUnmount(){
  this.props.resetReducerState()
}
  // getRiderUnAnsweredQuestions = ()=>{

  //   const data = {
  //     offset : 0,
  //     submitted_dttm :this.props.submitted_dttm,
  //     props:this.props
  //   }

  //   if(this.props.isAnswered == "Answered"){
    
  //     this.props.getRiderAnsweredQuestions(data)
  //   }
  //   else{
  //     this.props.getRiderUnAnsweredQuestions(data)
  //   }
  // }
  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.PointsHistory_GET_status ===PointsHistoryStatus.PointsHistory_GET.SUCCESS ||
      nextProps.PointsHistory_GET_status ===PointsHistoryStatus.PointsHistory_GET.FAILED 
      ){
      nextProps.setLoading(false)
    }

    if(nextProps.user_id_flag && nextProps.PointsHistory_GET_status !==PointsHistoryStatus.PointsHistory_GET.LOADING){
      // alert(nextProps.user_id)
      let data={
        user_id:nextProps.user_id,
        offset: (nextProps.activePage - 1) * Api_Pagination.PointsHistoryLimit
      }
      // alert(data.offset)
      nextProps.getPointsHistoryByUserId(data)
      nextProps.clear_user_id()
      nextProps.setLoading(true)
    }
    
    //prevState.activePage !== nextProps.activePage
  //   if(prevState.submitted_dttm !== nextProps.submitted_dttm || prevState.isAnswered !== nextProps.isAnswered || prevState.activePage !== nextProps.activePage){
  //     const data = {
  //       offset : (nextProps.activePage - 1) * 10,
  //       submitted_dttm :nextProps.submitted_dttm ,
  //       props:nextProps
  //     }
  //     if(nextProps.isAnswered == "Answered"){
    
  //       nextProps.getRiderAnsweredQuestions(data)
  //     }
  //     else{
  //       nextProps.getRiderUnAnsweredQuestions(data)
  //     }
  //     return{
  //       submitted_dttm:nextProps.submitted_dttm,
  //       isAnswered:nextProps.isAnswered,
  //       activePage:nextProps.activePage
  //     }
  //  }
   
   return null;
 }
  getScreen(status) {
    switch (status) {
      case PointsHistoryStatus.PointsHistory_GET.NEW:
        return (
          <PointsHistory  data={this.props.PointsHistory} />
        );

      case PointsHistoryStatus.PointsHistory_GET.SUCCESS:

      // alert(JSON.stringify(this.props.PointsCount)) 
      console.log("this.props.PointsHistory:", this.props.PointsHistory)
        return (
          <PointsHistory  data={this.props.PointsHistory}  setNoOfPages={this.props.setNoOfPages} PointsCount={this.props.PointsCount}/>
          // this.props.PointsHistory.length > 0 ?
          // this.props.PointsHistory.map((item)=>{
          //   return(

          //     <RiderSupportAnsCard key ={item.rider_support_request_id}
          //     email_address = {item.email_address}
          //     submitted_dttm = {this.state.submitted_dttm}
          //     question = {item.question}
          //     response = {item.response}
          //     response_dttm = {item.response_dttm}
          //     isAnswered = {this.state.isAnswered}
          //     rider_support_request_id = {item.rider_support_request_id}
          //     getRiderUnAnsweredQuestions = {this.getRiderUnAnsweredQuestions}
          //     phone = {item.phone}
          //     />
          
          //   )
          // }):
          // this.state.isAnswered == "Answered"?
          // < QuestionsEmptyScreen message = {"No Answered Questions yet"} />
          // :< QuestionsEmptyScreen message = {"No Unanswered Questions yet"} />
          
        );
        break;
      case PointsHistoryStatus.PointsHistory_GET.FAILED:
        
        toast.error(this.props.PointsHistory_Error)
        return (
          <PointsHistory  data={[]} />
           );

      case PointsHistoryStatus.PointsHistory_GET.LOADING:
     
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Loading />
          </div>
        );
        break;
      default:
        return <div />;
    }
  }
  render() {
    return this.getScreen(this.props.PointsHistory_GET_status);
  }
}

export default PointsHistoryView;
